import { createFileRoute, redirect } from '@tanstack/react-router'

// Bare /issues has no admin list page — issues are surfaced via the
// entity-detail Issues tab and the HOD inbox (/hod/issues). Redirect
// any direct hit to the entities list so the user lands somewhere useful.
export const Route = createFileRoute('/issues/')({
  beforeLoad: () => {
    throw redirect({ to: '/entities' })
  },
})
